import React from 'react'

interface Step {
	title: string
	component?: React.ElementRef<any>
}

interface StepsProps {
	steps: Step[]
	activeStep: number
	containerId?: string
}

const Steps = ({ steps, activeStep, containerId }: StepsProps) => {
	return steps.length > 0 ? (
		<>
			<div className="flex items-stretch bg-white" id={containerId || 'steps'}>
				{steps.map((step, index) => {
					return (
						<span
							className={`${
								index === activeStep ? 'bg-yellow-200' : ''
							} p-4 font-bold border-r text-left relative flex flex-col items-start justify-center`}
							key={index}
							data-index={index}
						>
							<span
								style={{
									minWidth: '2rem',
									minHeight: '2rem',
								}}
								className={
									index === activeStep
										? 'inline-block bg-purple-900 border border-purple-800 text-white rounded-full w-6 h-6 text-center pt-1 text-sm'
										: 'inline-block border border-gray-300 bg-white text-gray-600 rounded-full w-6 h-6 text-center pt-1 text-sm'
								}
							>
								{index + 1}
							</span>
							<span
								className={`font-sans text-xs mt-2 w-full whitespace-nowrap ${
									index === activeStep ? 'block' : 'hidden sm:block'
								}`}
							>
								{step.title}
							</span>
						</span>
					)
				})}
			</div>
			{steps[activeStep].component ?? null}
		</>
	) : null
}

export default Steps
